function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_662_8603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 21,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5191 0.118164C5.76028 0.118164 2.8855 5.43538 2.8855 11.9944C2.8855 18.5536 5.76028 23.8816 12.5191 23.8816C19.278 23.8816 22.1528 18.5536 22.1528 11.9944C22.1528 5.43538 19.278 0.118164 12.5191 0.118164Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_662_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.97 1.72162C17.2142 1.18333 16.3487 0.767449 15.3678 0.496094L12.5066 12.1632L17.97 1.72162Z",
    fill: "#F05549",
    style: (_ref2 = {
      fill: "#F05549"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.9412 0.3333 0.2863)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5065 12.1627L19.9269 3.70051C19.3772 2.92441 18.7204 2.2515 17.9493 1.70605L12.5065 12.1627Z",
    fill: "#FEC23D",
    style: (_ref3 = {
      fill: "#FEC23D"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.9961 0.7608 0.2392)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5066 12.1633L21.1769 6.09172C20.8489 5.21878 20.4334 4.41624 19.927 3.70117L12.5066 12.1633Z",
    fill: "#0D4D8E",
    style: (_ref4 = {
      fill: "#0D4D8E"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.0510 0.3020 0.5569)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3676 0.495979C14.5044 0.257175 13.5522 0.129883 12.5065 0.129883V12.1631L15.3676 0.495979Z",
    fill: "#00AB54",
    style: (_ref5 = {
      fill: "#00AB54"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.0000 0.6706 0.3294)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0346 22.2405L12.5065 12.1631L15.1674 23.5686C16.2596 23.292 17.2127 22.8394 18.0346 22.2405Z",
    fill: "#00AB54",
    style: (_ref6 = {
      fill: "#00AB54"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.0000 0.6706 0.3294)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0346 22.2405C18.7768 21.6998 19.4117 21.0396 19.9447 20.2812L12.5065 12.1631L18.0346 22.2405Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9446 20.2812C20.4364 19.5814 20.8417 18.7984 21.164 17.9484L12.5065 12.1631L19.9446 20.2812Z",
    fill: "#FEC23D",
    style: (_ref7 = {
      fill: "#FEC23D"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.9961 0.7608 0.2392)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8268 15.5557C21.9682 14.8046 22.0609 14.0216 22.1065 13.2146L12.5065 12.1631L21.8268 15.5557Z",
    fill: "#F05549",
    style: (_ref8 = {
      fill: "#F05549"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.9412 0.3333 0.2863)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8415 8.53288C21.6843 7.67387 21.4641 6.85596 21.1769 6.0918L12.5066 12.1634L21.8415 8.53288Z",
    fill: "#252524",
    style: (_ref9 = {
      fill: "#252524"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.1451 0.1451 0.1412)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1116 10.8981C22.0696 10.0828 21.9803 9.29138 21.8414 8.53223L12.5065 12.1628L22.1116 10.8981Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1064 13.2146C22.1289 12.8173 22.14 12.4141 22.14 12.0062C22.14 11.6326 22.1303 11.2633 22.1115 10.8984L12.5065 12.1631L22.1064 13.2146Z",
    fill: "#00AB54",
    style: (_ref10 = {
      fill: "#00AB54"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.0000 0.6706 0.3294)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.164 17.9484C21.4482 17.1988 21.6682 16.3974 21.8268 15.5557L12.5065 12.1631L21.164 17.9484Z",
    fill: "#0D4D8E",
    style: (_ref11 = {
      fill: "#0D4D8E"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.0510 0.3020 0.5569)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04321 1.72162C7.79903 1.18333 8.66465 0.767449 9.64557 0.496094L12.5067 12.1632L7.04321 1.72162Z",
    fill: "#252524",
    style: (_ref12 = {
      fill: "#252524"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.1451 0.1451 0.1412)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5064 12.1627L5.08606 3.70051C5.6357 2.92441 6.29253 2.2515 7.0636 1.70605L12.5064 12.1627Z",
    fill: "#FEC23D",
    style: (_ref13 = {
      fill: "#FEC23D"
    }, _defineProperty(_ref13, "fill", "color(display-p3 0.9961 0.7608 0.2392)"), _defineProperty(_ref13, "fillOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5065 12.1633L3.83618 6.09172C4.16428 5.21878 4.57977 4.41624 5.08615 3.70117L12.5065 12.1633Z",
    fill: "#F05549",
    style: (_ref14 = {
      fill: "#F05549"
    }, _defineProperty(_ref14, "fill", "color(display-p3 0.9412 0.3333 0.2863)"), _defineProperty(_ref14, "fillOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64539 0.495979C10.5086 0.257175 11.4608 0.129883 12.5065 0.129883V12.1631L9.64539 0.495979Z",
    fill: "#FEC23D",
    style: (_ref15 = {
      fill: "#FEC23D"
    }, _defineProperty(_ref15, "fill", "color(display-p3 0.9961 0.7608 0.2392)"), _defineProperty(_ref15, "fillOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97827 22.2405L12.5064 12.1631L9.84549 23.5686C8.75331 23.292 7.80017 22.8394 6.97827 22.2405Z",
    fill: "#FEC23D",
    style: (_ref16 = {
      fill: "#FEC23D"
    }, _defineProperty(_ref16, "fill", "color(display-p3 0.9961 0.7608 0.2392)"), _defineProperty(_ref16, "fillOpacity", 1), _ref16)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97823 22.2405C6.23604 21.6998 5.6011 21.0396 5.06812 20.2812L12.5064 12.1631L6.97823 22.2405Z",
    fill: "#F05549",
    style: (_ref17 = {
      fill: "#F05549"
    }, _defineProperty(_ref17, "fill", "color(display-p3 0.9412 0.3333 0.2863)"), _defineProperty(_ref17, "fillOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06828 20.2812C4.57639 19.5814 4.17121 18.7984 3.84888 17.9484L12.5064 12.1631L5.06828 20.2812Z",
    fill: "#252524",
    style: (_ref18 = {
      fill: "#252524"
    }, _defineProperty(_ref18, "fill", "color(display-p3 0.1451 0.1451 0.1412)"), _defineProperty(_ref18, "fillOpacity", 1), _ref18)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18608 15.5557C3.04471 14.8046 2.95196 14.0216 2.90637 13.2146L12.5064 12.1631L3.18608 15.5557Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17163 8.53288C3.32884 7.67387 3.5491 6.85596 3.83621 6.0918L12.5066 12.1634L3.17163 8.53288Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90125 10.8981C2.94328 10.0828 3.03254 9.29138 3.17147 8.53223L12.5064 12.1628L2.90125 10.8981Z",
    fill: "#0D4D8E",
    style: (_ref19 = {
      fill: "#0D4D8E"
    }, _defineProperty(_ref19, "fill", "color(display-p3 0.0510 0.3020 0.5569)"), _defineProperty(_ref19, "fillOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9064 13.2146C2.88383 12.8122 2.87262 12.4092 2.8728 12.0062C2.8728 11.6326 2.88253 11.2633 2.90134 10.8984L12.5064 12.1631L2.9064 13.2146Z",
    fill: "#F05549",
    style: (_ref20 = {
      fill: "#F05549"
    }, _defineProperty(_ref20, "fill", "color(display-p3 0.9412 0.3333 0.2863)"), _defineProperty(_ref20, "fillOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84893 17.9484C3.56468 17.1988 3.3447 16.3974 3.18616 15.5557L12.5065 12.1631L3.84893 17.9484Z",
    fill: "#00AB54",
    style: (_ref21 = {
      fill: "#00AB54"
    }, _defineProperty(_ref21, "fill", "color(display-p3 0.0000 0.6706 0.3294)"), _defineProperty(_ref21, "fillOpacity", 1), _ref21)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5065 4.97228C12.5065 4.97228 15.7002 5.08222 15.7684 4.89588C15.8407 4.69818 16.1048 3.84825 16.1048 3.28889C16.1048 2.28056 15.0892 1.81588 14.788 1.66547C14.0258 1.28499 13.1587 1.21191 12.5065 1.21191C11.8544 1.21191 10.9872 1.28499 10.2251 1.66547C9.92393 1.81588 8.9082 2.28056 8.9082 3.28889C8.9082 3.84825 9.17231 4.69818 9.24468 4.89588C9.31286 5.08222 12.5065 4.97228 12.5065 4.97228Z",
    fill: "#C6D8E3",
    style: (_ref22 = {
      fill: "#C6D8E3"
    }, _defineProperty(_ref22, "fill", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref22, "fillOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_662_8603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 1,
    width: 9,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5065 4.97228C12.5065 4.97228 15.7002 5.08222 15.7684 4.89588C15.8407 4.69818 16.1048 3.84825 16.1048 3.28889C16.1048 2.28056 15.0892 1.81588 14.788 1.66547C14.0258 1.28499 13.1587 1.21191 12.5065 1.21191C11.8544 1.21191 10.9872 1.28499 10.2251 1.66547C9.92393 1.81588 8.9082 2.28056 8.9082 3.28889C8.9082 3.84825 9.17231 4.69818 9.24468 4.89588C9.31286 5.08222 12.5065 4.97228 12.5065 4.97228Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_662_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0085 4.56464C10.3489 4.32025 9.62117 3.96219 9.56504 3.7981C9.50291 3.61659 9.30786 2.90018 9.232 2.56628C9.22135 2.52025 9.21123 2.47409 9.20166 2.42781C9.51817 2.00692 10.0045 1.7751 10.2107 1.67285C10.2059 1.72101 10.2109 1.7984 10.2392 1.92272C10.315 2.25661 10.4553 3.02508 10.5283 3.20245C10.5887 3.34908 11.1857 3.7511 11.7087 4.08203C11.3706 4.18853 11.116 4.36055 11.0085 4.56464ZM14.0082 4.56569C13.9012 4.36159 13.6471 4.18946 13.3096 4.08273C13.8329 3.75169 14.4307 3.3492 14.4911 3.20245C14.5642 3.02508 14.7044 2.25661 14.7803 1.92272C14.8079 1.80113 14.8134 1.72444 14.8091 1.67605C15.0199 1.7804 15.5034 2.01362 15.8165 2.43428C15.8095 2.46846 15.7999 2.51149 15.7875 2.56628C15.7116 2.90018 15.5166 3.61659 15.4545 3.7981C15.3982 3.96242 14.6686 4.32124 14.0082 4.56569Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5064 2.7959C14.4379 2.7959 16.2072 3.77056 15.761 4.91544C15.5368 5.49081 14.3391 6.2647 12.5064 6.2647C10.6737 6.2647 9.47599 5.49081 9.25177 4.91544C8.80565 3.77056 10.5749 2.7959 12.5064 2.7959Z",
    fill: "#3C7792",
    style: (_ref23 = {
      fill: "#3C7792"
    }, _defineProperty(_ref23, "fill", "color(display-p3 0.2353 0.4667 0.5725)"), _defineProperty(_ref23, "fillOpacity", 1), _ref23)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.483 3.75988C12.9219 3.75988 13.0912 3.83878 13.2463 3.89014C13.3871 3.93679 13.76 3.97062 13.9404 3.74032C14.1249 3.50466 14.4916 3.50081 14.8705 3.59864C14.8705 3.59864 14.2662 2.92969 12.483 2.92969C10.6998 2.92969 10.0955 3.59864 10.0955 3.59864C10.4743 3.50081 10.8411 3.50466 11.0256 3.74032C11.2059 3.97062 11.5789 3.93679 11.7196 3.89014C11.8747 3.83878 12.0441 3.75988 12.483 3.75988Z",
    fill: "#6098C1",
    style: (_ref24 = {
      fill: "#6098C1"
    }, _defineProperty(_ref24, "fill", "color(display-p3 0.3765 0.5961 0.7569)"), _defineProperty(_ref24, "fillOpacity", 1), _ref24)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97365 7.59954C8.9078 7.30571 8.97091 6.7227 9.15234 6.41216C9.59456 5.6551 10.5128 5.80464 11.077 6.18162V5.38282C10.7522 5.03413 9.49936 4.8885 8.77236 5.54481C7.81585 6.4082 8.14948 8.62504 8.14948 8.62504L8.97365 7.59954Z",
    fill: "url(#paint0_linear_662_8603)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97365 7.59954C8.9078 7.30571 8.97091 6.7227 9.15234 6.41216C9.59456 5.6551 10.5128 5.80464 11.077 6.18162V5.38282C10.7522 5.03413 9.49936 4.8885 8.77236 5.54481C7.81585 6.4082 8.14948 8.62504 8.14948 8.62504L8.97365 7.59954Z",
    fill: "#C6D8E3",
    style: (_ref25 = {
      fill: "#C6D8E3"
    }, _defineProperty(_ref25, "fill", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref25, "fillOpacity", 1), _ref25)
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_662_8603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 4,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97365 7.59954C8.9078 7.30571 8.97091 6.7227 9.15234 6.41216C9.59456 5.6551 10.5128 5.80464 11.077 6.18162V5.38282C10.7522 5.03413 9.49936 4.8885 8.77236 5.54481C7.81585 6.4082 8.14948 8.62504 8.14948 8.62504L8.97365 7.59954Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_662_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83612 7.87973C8.83612 7.87973 8.55618 6.39362 9.42839 5.87671C10.3006 5.3598 11.077 6.01838 11.077 6.01838L10.5267 7.31972L8.83612 7.87973Z",
    fill: "#6098C1",
    style: (_ref26 = {
      fill: "#6098C1"
    }, _defineProperty(_ref26, "fill", "color(display-p3 0.3765 0.5961 0.7569)"), _defineProperty(_ref26, "fillOpacity", 1), _ref26)
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.863 8.62504C16.863 8.62504 17.1966 6.4082 16.2401 5.54481C15.5131 4.8885 14.2603 5.03413 13.9355 5.38282V6.18162C14.4997 5.80464 15.4179 5.6551 15.8602 6.41216C16.0416 6.7227 16.1047 7.30571 16.0388 7.59954L16.863 8.62504Z",
    fill: "url(#paint1_linear_662_8603)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.863 8.62504C16.863 8.62504 17.1966 6.4082 16.2401 5.54481C15.5131 4.8885 14.2603 5.03413 13.9355 5.38282V6.18162C14.4997 5.80464 15.4179 5.6551 15.8602 6.41216C16.0416 6.7227 16.1047 7.30571 16.0388 7.59954L16.863 8.62504Z",
    fill: "#C6D8E3",
    style: (_ref27 = {
      fill: "#C6D8E3"
    }, _defineProperty(_ref27, "fill", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref27, "fillOpacity", 1), _ref27)
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_662_8603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 5,
    width: 4,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.863 8.62504C16.863 8.62504 17.1966 6.4082 16.2401 5.54481C15.5131 4.8885 14.2603 5.03413 13.9355 5.38282V6.18162C14.4997 5.80464 15.4179 5.6551 15.8602 6.41216C16.0416 6.7227 16.1047 7.30571 16.0388 7.59954L16.863 8.62504Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_662_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1763 7.87973C16.1763 7.87973 16.4563 6.39362 15.5841 5.87671C14.7119 5.3598 13.9355 6.01838 13.9355 6.01838L14.4858 7.31972L16.1763 7.87973Z",
    fill: "#6098C1",
    style: (_ref28 = {
      fill: "#6098C1"
    }, _defineProperty(_ref28, "fill", "color(display-p3 0.3765 0.5961 0.7569)"), _defineProperty(_ref28, "fillOpacity", 1), _ref28)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5077 3.96582C11.6486 3.96582 10.9521 4.33145 10.9521 4.78251V8.49529H14.0634V4.78251C14.0634 4.33145 13.3669 3.96582 12.5077 3.96582Z",
    fill: "#C6D8E3",
    style: (_ref29 = {
      fill: "#C6D8E3"
    }, _defineProperty(_ref29, "fill", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref29, "fillOpacity", 1), _ref29)
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_662_8603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 3,
    width: 5,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5049 3.96582C11.6457 3.96582 10.9492 4.33145 10.9492 4.78251V8.49529H14.0605V4.78251C14.0605 4.33145 13.364 3.96582 12.5049 3.96582Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_662_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 6.44033V4.4245C11.2915 4.18232 11.4662 4.09986 11.705 4.05945L11.933 4.02084C11.933 4.02084 11.7027 4.00052 11.6982 4.2756C11.6936 4.55069 11.6894 5.68001 11.6992 5.80748C11.7218 6.10102 11.8596 6.3241 11.9604 6.3195C12.0613 6.3149 11.2915 6.44033 11.2915 6.44033ZM13.718 6.44033V4.4245C13.718 4.18232 13.5432 4.09986 13.3045 4.05945L13.0765 4.02084C13.0765 4.02084 13.3067 4.00052 13.3113 4.2756C13.3159 4.55069 13.3201 5.68001 13.3103 5.80748C13.2877 6.10102 13.1499 6.3241 13.049 6.3195C12.9482 6.3149 13.718 6.44033 13.718 6.44033Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7654 20.3321C18.7424 21.7383 17.4185 22.7147 15.812 23.2571C15.7988 23.1726 15.7645 23.0756 15.7121 22.9719C15.5846 22.7197 14.6176 21.1086 14.4597 20.1588C14.2555 18.9299 14.8823 18.1895 15.5679 16.664C16.3643 14.8922 17.7332 11.4982 17.1951 9.35743C16.6012 6.99478 14.3327 6.25228 12.5063 6.25228C10.68 6.25228 8.41142 6.99478 7.81753 9.35743C7.27942 11.4982 8.64839 14.8922 9.44473 16.664C10.1304 18.1895 10.7572 18.9299 10.5529 20.1588C10.395 21.1086 9.42808 22.7197 9.30057 22.9719C9.24811 23.0756 9.21381 23.1726 9.20071 23.2571C7.59406 22.7148 6.27015 21.7383 5.24714 20.3321C3.76823 18.2992 2.98645 15.418 2.98645 12C2.98645 8.58029 3.76701 5.69915 5.24359 3.66789C6.89874 1.39101 9.34232 0.236533 12.5063 0.236533C15.6703 0.236533 18.1138 1.39101 19.769 3.66789C21.2455 5.69915 22.026 8.58029 22.026 12C22.026 15.418 21.2443 18.2992 19.7654 20.3321ZM19.9602 3.52884C18.2581 1.18732 15.7502 0 12.5063 0C9.26243 0 6.75446 1.18726 5.05232 3.52884C3.54616 5.60074 2.75 8.52998 2.75 12C2.75 15.4683 3.54739 18.3976 5.05593 20.4712C6.17786 22.0134 7.64967 23.0526 9.44858 23.5839C9.49865 23.6001 9.56002 23.6198 9.63408 23.6418C9.67466 23.6539 9.72456 23.6482 9.77842 23.6425C9.83501 23.6365 9.89586 23.6305 9.95478 23.6452C10.0457 23.6679 10.1229 23.7691 10.2344 23.7921C10.7539 23.8993 11.5 24 12.5059 24H12.5067C13.5126 24 14.2588 23.8993 14.7783 23.7921C14.9044 23.766 15.009 23.6542 15.1089 23.6287C15.1598 23.6157 15.2094 23.6252 15.2558 23.6346C15.3004 23.6436 15.342 23.6527 15.3786 23.6418C15.4526 23.6198 15.5141 23.6001 15.5641 23.5839C17.363 23.0525 18.8347 22.0133 19.9566 20.4712C21.4652 18.3976 22.2626 15.4683 22.2626 12C22.2626 8.52998 21.4664 5.60074 19.9602 3.52884Z",
    fill: "#C6D8E3",
    style: (_ref30 = {
      fill: "#C6D8E3"
    }, _defineProperty(_ref30, "fill", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref30, "fillOpacity", 1), _ref30)
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_662_8603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 11,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5068 23.9997C14.4487 23.9997 15.4225 23.6245 15.6668 23.5507C15.8653 23.4908 15.8558 23.2558 15.7122 22.9716C15.5846 22.7194 14.6177 21.1082 14.4598 20.1585C14.2555 18.9296 14.8823 18.1891 15.568 16.6637C16.3643 14.8919 17.7332 11.4978 17.1952 9.3571C16.6012 6.99445 14.3327 6.25195 12.5064 6.25195C10.68 6.25195 8.41147 6.99445 7.81758 9.3571C7.27947 11.4978 8.64845 14.8919 9.44479 16.6637C10.1304 18.1891 10.7572 18.9296 10.553 20.1585C10.3951 21.1082 9.42813 22.7194 9.30062 22.9716C9.15692 23.2558 9.14743 23.4908 9.34598 23.5507C9.59023 23.6245 10.564 23.9997 12.5059 23.9997H12.5068Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_662_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2345 23.7917C10.0323 23.7504 9.83199 23.7002 9.63416 23.6415C9.65174 23.6467 9.67113 23.6487 9.6918 23.6487C9.71876 23.6487 9.74798 23.6454 9.77849 23.6422C9.80972 23.6384 9.84113 23.6362 9.87259 23.6357C9.90001 23.6357 9.92767 23.6381 9.95486 23.6449C10.0457 23.6676 10.123 23.7687 10.2345 23.7917Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2345 23.7918C10.1231 23.7688 10.0458 23.6676 9.95492 23.6449C9.92797 23.6385 9.90034 23.6354 9.87265 23.6358C9.84068 23.6358 9.80901 23.639 9.77855 23.6422C9.74805 23.6454 9.71882 23.6487 9.69186 23.6487C9.67119 23.6487 9.6518 23.6468 9.63422 23.6415C9.67387 23.4295 9.75393 23.2054 9.90333 22.9797C10.4505 22.1534 10.7552 21.129 10.8884 20.5522C11.3319 18.6323 9.27637 17.0988 8.4565 11.6324C7.83047 7.45829 10.6066 6.69384 11.5035 6.58879L11.8586 6.53906C8.60387 7.66152 9.44964 12.4501 10.1157 14.803C10.9577 17.7768 11.5035 19.0302 11.3514 20.5317C11.3044 20.9962 11.0035 22.1198 10.5414 22.9784C10.3763 23.2851 10.2855 23.4007 10.2345 23.7918ZM14.7784 23.7918C14.9045 23.7657 15.0091 23.6539 15.109 23.6284C15.1269 23.6238 15.1447 23.6221 15.1621 23.6221C15.1944 23.6221 15.2259 23.6282 15.256 23.6343C15.286 23.6404 15.3147 23.6465 15.3414 23.6465C15.3543 23.6465 15.3668 23.6451 15.3787 23.6415C15.1809 23.7002 14.9806 23.7504 14.7784 23.7918Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7784 23.7918C14.7274 23.4007 14.6366 23.2851 14.4715 22.9784C14.0093 22.1198 13.7085 20.9962 13.6614 20.5317C13.5094 19.0302 14.0552 17.7768 14.8971 14.803C15.5632 12.4501 16.409 7.66152 13.1543 6.53906L13.5094 6.58879C14.4062 6.69384 17.1824 7.45829 16.5564 11.6324C15.7365 17.0988 13.6809 18.6323 14.1245 20.5522C14.2577 21.129 14.5623 22.1534 15.1095 22.9797C15.2589 23.2054 15.339 23.4295 15.3787 23.6415C15.3665 23.645 15.354 23.6467 15.3413 23.6465C15.3147 23.6465 15.286 23.6404 15.2559 23.6343C15.2258 23.6282 15.1944 23.6221 15.1621 23.6221C15.1446 23.6221 15.1268 23.6238 15.109 23.6284C15.009 23.6539 14.9045 23.7657 14.7784 23.7918Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5064 10.7073C11.8909 10.7073 11.2946 10.7335 10.7244 10.7831C10.7604 9.83094 11.5458 9.06736 12.5064 9.06736C13.4671 9.06736 14.2525 9.83094 14.2885 10.7831C13.7182 10.7335 13.1219 10.7073 12.5064 10.7073ZM12.5064 12.6353C11.5986 12.6353 10.8475 11.9534 10.7371 11.0749C11.3254 11.0217 11.9158 10.9952 12.5064 10.9954C13.1138 10.9954 13.7066 11.0231 14.2758 11.0749C14.1654 11.9534 13.4143 12.6353 12.5064 12.6353ZM14.5772 10.8104C14.5553 9.68676 13.6352 8.7793 12.5064 8.7793C11.3777 8.7793 10.4575 9.68676 10.4357 10.8104C7.16523 11.1451 4.82495 12.2595 4.82495 13.6194H5.11299C5.11299 12.449 7.40553 11.4283 10.4504 11.1032C10.5752 12.1273 11.4493 12.9234 12.5064 12.9234C13.5635 12.9234 14.4377 12.1273 14.5624 11.1032C17.6074 11.4283 19.8998 12.449 19.8998 13.6194H20.1879C20.1879 12.2595 17.8476 11.1452 14.5772 10.8104Z",
    fill: "#6098C1",
    style: (_ref31 = {
      fill: "#6098C1"
    }, _defineProperty(_ref31, "fill", "color(display-p3 0.3765 0.5961 0.7569)"), _defineProperty(_ref31, "fillOpacity", 1), _ref31)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.2739 23.4315C11.2739 23.4315 11.6517 20.5439 12.5062 20.5439C13.3606 20.5439 13.7385 23.4315 13.7385 23.4315C12.3684 23.7477 11.2739 23.4315 11.2739 23.4315Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_662_8603",
    x1: 10.9248,
    y1: 6.85594,
    x2: 8.08465,
    y2: 6.85594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6098C1",
    style: (_ref32 = {
      stopColor: "#6098C1"
    }, _defineProperty(_ref32, "stopColor", "color(display-p3 0.3765 0.5961 0.7569)"), _defineProperty(_ref32, "stopOpacity", 1), _ref32)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D8E3",
    style: (_ref33 = {
      stopColor: "#C6D8E3"
    }, _defineProperty(_ref33, "stopColor", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref33, "stopOpacity", 1), _ref33)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_662_8603",
    x1: 14.0877,
    y1: 6.85594,
    x2: 16.9279,
    y2: 6.85594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6098C1",
    style: (_ref34 = {
      stopColor: "#6098C1"
    }, _defineProperty(_ref34, "stopColor", "color(display-p3 0.3765 0.5961 0.7569)"), _defineProperty(_ref34, "stopOpacity", 1), _ref34)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D8E3",
    style: (_ref35 = {
      stopColor: "#C6D8E3"
    }, _defineProperty(_ref35, "stopColor", "color(display-p3 0.7765 0.8471 0.8902)"), _defineProperty(_ref35, "stopOpacity", 1), _ref35)
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.e1ffaeb9156b1609d1e99aa3d831cd49.svg";
export { ForwardRef as ReactComponent };